import React, { useEffect, useState } from 'react'
import { useHover, useInterval, useTimeoutFn } from 'react-use'
import type { ButtonProps } from 'react-bootstrap'
import { Stack } from 'react-bootstrap'
import { BusyButton } from '../BusyButton'
import { useHistory } from '@ztechapps/common.hook'

export type AutomaticRedirectButtonProps = {
  redirectTo?: string
  redirectTimeout?: number
} & ButtonProps

export const AutomaticRedirectButton = ({
  title = 'Back',
  redirectTo = '/',
  redirectTimeout = 30,
  ...rest
}: AutomaticRedirectButtonProps) => {
  const history = useHistory()
  const [count, setCount] = useState(redirectTimeout)

  const element = (
    <div>
      <BusyButton text={title} onClick={() => onRedirect()} {...rest} />
    </div>
  )
  const [hoverable, hovered] = useHover(element)

  const onRedirect = () => {
    history.push(redirectTo)
  }

  // Define a delayed function to navigate after 5 seconds
  const [, , reset] = useTimeoutFn(onRedirect, 1000 * redirectTimeout)

  // Countdown using useInterval (stops when hovering)
  useInterval(() => setCount((prev) => prev - 1), hovered || count <= 0 ? null : 1000)

  useEffect(() => {
    if (hovered) {
      reset() // Prevent navigation when hovering
    }
  }, [hovered, reset])

  return (
    <Stack gap={1}>
      {hoverable}

      <small>
        Redirecting automatically after <b>{count}</b> seconds
      </small>
    </Stack>
  )
}
